// extracted by mini-css-extract-plugin
export default {"welcome-slider":"WelcomeSlider_welcome-slider__DrRud"};